import './Header.css';
const Header = () =>{
    return (
        <div>
            < span className= "header">Watchlist!</span>
        </div>
        
    )
}
export default Header;